import Vue from 'vue';

// Credit to https://vuetifyjs.com/

const ProgressCircular = Vue.extend({
  template: `
    <div class="progress-circular" :class="classObject" :style="styleObject">
      <svg xmlns="http://www.w3.org/2000/svg"
          :height="svgSize"
          :width="svgSize"
          :viewBox="viewBox"
          :style="svgStyleObject">
          <circle
              v-if="!indeterminate"
              class="progress-circular__underlay"
              fill="transparent"
              :cx="cxy"
              :cy="cxy"
              :r="radius"
              :stroke-width="width"
              :stroke-dasharray="strokeDashArray"
              :stroke-dashoffset="0">
          </circle>
          <circle
              class="progress-circular__overlay"
              :fill="fill"
              :cx="cxy"
              :cy="cxy"
              :r="radius"
              :stroke-width="width"
              :stroke-dasharray="strokeDashArray"
              :stroke-dashoffset="strokeDashOffset">
          </circle>
      </svg>
      <div class="progress-circular__info">
        <slot></slot>
      </div>
    </div>
  `,
  props: {
    fill: {
      type: [Boolean, String],
      default() {
        return this.indeterminate ? 'none' : 'transparent';
      },
    },

    indeterminate: {
      type: Boolean,
      default: false,
    },

    rotate: {
      type: Number,
      default: 0,
    },

    size: {
      type: Number,
      default: 32,
    },

    width: {
      type: Number,
      default: 4,
    },

    value: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    circumference() {
      return 2 * Math.PI * this.radius;
    },

    classObject() {
      return {
        'progress-circular--indeterminate': this.indeterminate,
      };
    },

    cxy() {
      return this.indeterminate ? 50 : this.size / 2;
    },

    normalizedValue() {
      if (this.value < 0) {
        return 0;
      }
      if (this.value > 100) {
        return 100;
      }
      return this.value;
    },

    radius() {
      return this.indeterminate ? 20 : (this.size - this.width) / 2;
    },

    strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },

    strokeDashOffset() {
      return `${((100 - this.normalizedValue) / 100) * this.circumference}px`;
    },

    styleObject() {
      return {
        height: `${this.size}px`,
        width: `${this.size}px`,
      };
    },

    svgSize() {
      return this.indeterminate ? false : this.size;
    },

    svgStyleObject() {
      return {
        transform: `rotate(${this.rotate}deg)`,
      };
    },

    viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    },
  },
});

export default ProgressCircular;
